export default __webpack_public_path__ + "static/media/158.8ec7475d.gif";